"use client";
import React from "react";

/**
 * Renders a fullscreen expand SVG icon.
 * @returns {React.ReactElement} The fullscreen icon
 */
export const FullscreenIcon = () => (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" aria-hidden="true">
    <g filter="url(#filter0_d_1362_4846)">
      <path
        d="M13.5 4.0498H17.55V8.0998"
        stroke="white"
        strokeWidth="1.38857"
        strokeLinecap="round"
        strokeLinejoin="round"
        shapeRendering="crispEdges"
      />
    </g>
    <path
      d="M12.1499 9.4498L17.5499 4.0498"
      stroke="white"
      strokeWidth="1.38857"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.0998 17.55H4.0498V13.5"
      stroke="white"
      strokeWidth="1.38857"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.4498 12.1499L4.0498 17.5499"
      stroke="white"
      strokeWidth="1.38857"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <filter
        id="filter0_d_1362_4846"
        x="9.71995"
        y="1.81261"
        width="11.6099"
        height="11.6099"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1.54286" />
        <feGaussianBlur stdDeviation="1.54286" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.33 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1362_4846" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1362_4846" result="shape" />
      </filter>
    </defs>
  </svg>
);

/**
 * Renders a muted speaker SVG icon.
 * @returns {React.ReactElement} The mute icon
 */
export const MuteIcon = () => (
  <svg width="22" height="21" viewBox="0 0 22 21" fill="none" aria-hidden="true">
    <g filter="url(#filter0_d_1362_4856)">
      <path
        d="M19.7998 6.98138L14.3998 12.3814M14.3998 6.98138L19.7998 12.3814M8.67069 2.8105L5.82157 5.65961C5.66591 5.81527 5.58809 5.8931 5.49726 5.94876C5.41674 5.9981 5.32895 6.03447 5.23711 6.05651C5.13353 6.08138 5.02347 6.08138 4.80334 6.08138H3.2398C2.73576 6.08138 2.48373 6.08138 2.29121 6.17947C2.12187 6.26576 1.98418 6.40344 1.8979 6.57279C1.7998 6.76531 1.7998 7.01733 1.7998 7.52138V11.8414C1.7998 12.3454 1.7998 12.5975 1.8979 12.79C1.98418 12.9593 2.12187 13.097 2.29121 13.1833C2.48373 13.2814 2.73576 13.2814 3.2398 13.2814H4.80334C5.02347 13.2814 5.13353 13.2814 5.23711 13.3062C5.32895 13.3283 5.41674 13.3647 5.49726 13.414C5.58809 13.4697 5.66591 13.5475 5.82157 13.7031L8.67069 16.5523C9.05623 16.9378 9.249 17.1306 9.4145 17.1436C9.5581 17.1549 9.69844 17.0968 9.79199 16.9872C9.8998 16.861 9.8998 16.5884 9.8998 16.0431V3.31961C9.8998 2.77438 9.8998 2.50176 9.79199 2.37552C9.69844 2.26599 9.5581 2.20786 9.4145 2.21916C9.249 2.23219 9.05623 2.42496 8.67069 2.8105Z"
        stroke="white"
        strokeWidth="1.35"
        strokeLinecap="square"
        shapeRendering="crispEdges"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_1362_4856"
        x="-1.96071"
        y="0.00011158"
        width="25.8008"
        height="22.4483"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1.54286" />
        <feGaussianBlur stdDeviation="1.54286" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.33 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1362_4856" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1362_4856" result="shape" />
      </filter>
    </defs>
  </svg>
);

/**
 * Renders an unmuted speaker SVG icon.
 * @returns {React.ReactElement} The unmute icon
 */
export const UnmuteIcon = () => (
  <svg width="22" height="21" viewBox="0 0 22 21" fill="none" aria-hidden="true">
    <g filter="url(#filter0_d_unmute)">
      <path
        d="M8.67069 2.8105L5.82157 5.65961C5.66591 5.81527 5.58809 5.8931 5.49726 5.94876C5.41674 5.9981 5.32895 6.03447 5.23711 6.05651C5.13353 6.08138 5.02347 6.08138 4.80334 6.08138H3.2398C2.73576 6.08138 2.48373 6.08138 2.29121 6.17947C2.12187 6.26576 1.98418 6.40344 1.8979 6.57279C1.7998 6.76531 1.7998 7.01733 1.7998 7.52138V11.8414C1.7998 12.3454 1.7998 12.5975 1.8979 12.79C1.98418 12.9593 2.12187 13.097 2.29121 13.1833C2.48373 13.2814 2.73576 13.2814 3.2398 13.2814H4.80334C5.02347 13.2814 5.13353 13.2814 5.23711 13.3062C5.32895 13.3283 5.41674 13.3647 5.49726 13.414C5.58809 13.4697 5.66591 13.5475 5.82157 13.7031L8.67069 16.5523C9.05623 16.9378 9.249 17.1306 9.4145 17.1436C9.5581 17.1549 9.69844 17.0968 9.79199 16.9872C9.8998 16.861 9.8998 16.5884 9.8998 16.0431V3.31961C9.8998 2.77438 9.8998 2.50176 9.79199 2.37552C9.69844 2.26599 9.5581 2.20786 9.4145 2.21916C9.249 2.23219 9.05623 2.42496 8.67069 2.8105Z"
        stroke="white"
        strokeWidth="1.35"
        strokeLinecap="square"
        shapeRendering="crispEdges"
      />
      <path
        d="M14.5 6.5C15.5 7.5 16 8.7 16 10C16 11.3 15.5 12.5 14.5 13.5"
        stroke="white"
        strokeWidth="1.35"
        strokeLinecap="round"
      />
      <path
        d="M17.5 4C19.5 6 20.5 8 20.5 10C20.5 12 19.5 14 17.5 16"
        stroke="white"
        strokeWidth="1.35"
        strokeLinecap="round"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_unmute"
        x="-1.96071"
        y="0.00011158"
        width="25.8008"
        height="22.4483"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1.54286" />
        <feGaussianBlur stdDeviation="1.54286" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.33 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_unmute" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_unmute" result="shape" />
      </filter>
    </defs>
  </svg>
);

/**
 * Renders a share/forward SVG icon.
 * @returns {React.ReactElement} The share icon
 */
export const ShareIcon = () => (
  <svg width="26" height="23" viewBox="0 0 26 23" fill="none" aria-hidden="true">
    <g filter="url(#filter0_d_1362_4858)">
      <path
        d="M4.36753 16.7672C5.75634 15.2881 9.40219 12.1502 14.5828 12.1502V16.2002L21.3328 9.4502L14.5828 2.7002V6.7502C10.1278 6.7502 4.41647 11.0069 3.78281 16.4989C3.77404 16.57 3.78813 16.6421 3.82305 16.7046C3.85796 16.7672 3.91189 16.8171 3.97702 16.8469C4.04214 16.8768 4.11509 16.8852 4.1853 16.8709C4.25551 16.8565 4.31934 16.8202 4.36753 16.7672Z"
        stroke="white"
        strokeWidth="1.38857"
        strokeLinecap="round"
        strokeLinejoin="round"
        shapeRendering="crispEdges"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_1362_4858"
        x="0.00022316"
        y="0.463002"
        width="25.1123"
        height="21.7373"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1.54286" />
        <feGaussianBlur stdDeviation="1.54286" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.33 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1362_4858" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1362_4858" result="shape" />
      </filter>
    </defs>
  </svg>
);

/**
 * Renders a play triangle SVG icon.
 * @returns {React.ReactElement} The play icon
 */
export const PlayIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M6.75 3.73851V20.261C6.75245 20.3929 6.78962 20.5217 6.85776 20.6346C6.9259 20.7475 7.0226 20.8405 7.13812 20.9041C7.25364 20.9677 7.38388 20.9997 7.51572 20.9969C7.64756 20.9941 7.77634 20.9566 7.88906 20.8882L21.3966 12.627C21.5045 12.5616 21.5937 12.4696 21.6556 12.3597C21.7175 12.2499 21.7501 12.1259 21.7501 11.9998C21.7501 11.8736 21.7175 11.7497 21.6556 11.6398C21.5937 11.5299 21.5045 11.4379 21.3966 11.3726L7.88906 3.11133C7.77634 3.0429 7.64756 3.0054 7.51572 3.00261C7.38388 2.99982 7.25364 3.03185 7.13812 3.09545C7.0226 3.15906 6.9259 3.25199 6.85776 3.36489C6.78962 3.47779 6.75245 3.60667 6.75 3.73851Z"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/**
 * Renders a pause (two bars) SVG icon.
 * @returns {React.ReactElement} The pause icon
 */
export const PauseIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <rect x="6" y="4" width="4" height="16" rx="1" stroke="white" strokeWidth="1.5" />
    <rect x="14" y="4" width="4" height="16" rx="1" stroke="white" strokeWidth="1.5" />
  </svg>
);
